module.exports = __webpack_public_path__ + "img/swiper2_m.ef119436.png";